// @ts-nocheck - TODO: properly type this file!

// Work is in progress on this file
import { Flex } from 'antd';
import { CustomShipmentText, CustomRadioGroup } from '@/components';
import NotificationFrequencySelector from './NotificationFrequencySelector';

const NotificationFrequency = ({
  form,
  selectedFrequencyOption,
  selectedFrequency,
  setSelectedFrequency,
  setSelectedFrequencyOption,
  notificationMethod,
  isShipmentSpecific = false,
  alertType,
  disableDigestFromTeamsNode = false,
}) => {
  const handleFrequency = (e) => {
    setSelectedFrequency(
      e?.target?.value === 'digest' ? 'ONCE_A_DAY' : e.target.value
    );
    setSelectedFrequencyOption(e?.target?.value);
    form.setFieldsValue({
      frequency: e?.target?.value === 'digest' ? 'ONCE_A_DAY' : e.target.value,
    });
  };
  return (
    <>
      <Flex vertical gap={16} style={{ marginBottom: '20px' }}>
        <div>
          <CustomShipmentText
            text={'Delivery'}
            fontSize='14px'
            fontWeight={600}
            marginBottom='10px'
          ></CustomShipmentText>
          <CustomRadioGroup
            value={selectedFrequencyOption}
            horizontal={false}
            gap='190px'
            onChange={handleFrequency}
            options={[
              { label: 'Real time (send on event)', value: 'REALTIME' },
              {
                label: 'Digest',
                value: 'digest',
                disabled:
                  (isShipmentSpecific
                    ? true
                    : alertType === 'AI_ACTION' ||
                        alertType === 'TEMPERATURE_GXP'
                      ? true
                      : notificationMethod &&
                        notificationMethod !== 'EMAIL' &&
                        notificationMethod !== 'SLACK' &&
                        notificationMethod !== 'TEAMS') ||
                  disableDigestFromTeamsNode,
              },
            ]}
          />
        </div>
        {selectedFrequencyOption !== 'REALTIME' && (
          <NotificationFrequencySelector
            setSelectedFrequency={setSelectedFrequency}
            selectedFrequency={selectedFrequency}
          />
        )}
      </Flex>
    </>
  );
};

export default NotificationFrequency;
